import * as React from 'react';

import * as ReactList from 'react-list';
import { matchPath } from 'react-router';

import DropdownMenu from '../../components/DropdownMenu';
// components
import Header from '../../components/Header';
import InboxPlaceholder from '../../components/InboxPlaceholder';
import LoadingAnimation from '../../components/LoadingAnimation';
import MenuItem from '../../components/MenuItem';
import {
    TabContent,
    Tabs,
} from '../../components/Tabs';
import env from '../../env';
import { FeatureFlag } from '../../types';
import SmartListComponent, {
    filterReducer,
    initialFilter,
    initialState,
    listReducer,
} from '../SmartList';
import ConversationListItem from './ConversationListItem';
import { ConversationsListContainerProps } from './ConversationsListTypes';
import SearchInput from './SearchInput';

const renderConversationListItem = (handleClick, conversationList, index, key) => (
    <ConversationListItem
        conversation={conversationList[index]}
        key={key}
        handleClick={handleClick}
    />
);

const ConversationsList: React.StatelessComponent<ConversationsListContainerProps> = ({ conversationsListStore, filteredConversations, setSearchValue, searchValue, handleClick, filterState, handleChangeFilter, session, loading, translate, onDesktop, unreadConversations }) => {
    const basePath = window.location.pathname.split('/messenger').join('');
    const hasConversationId = Boolean(matchPath(basePath, { path: '/conversation/:conversationId' })) || Boolean(matchPath(basePath, { path: '/log/:conversationId' }));
    const mobileMenu = []; // (conditionally push more elements in to build up a multi-icon menu
    const hasSmartList = (session.features && session.features.length > 0) ? session.features.includes(FeatureFlag.SMARTLIST) : false;
    const [selectedTab, setSelectedTab] = React.useState(0);
    const [state, dispatchState] = React.useReducer(listReducer, initialState);
    let selectedFiltersObj = initialFilter;
    const selectedFilters = sessionStorage.getItem('selectedFiltersStorage');
    if (selectedFilters) {
        selectedFiltersObj = JSON.parse(selectedFilters);
    }
    const [filters, dispatchFilters] = React.useReducer(filterReducer, selectedFiltersObj);
    const inboxPlaceholder = conversationsListStore.placeholder;
    const handleSwitchTabs = (index: number) => {
        setSelectedTab(index);
    };

    // @todo Include items as Logout, Settings, Edit my profile, etc...
    mobileMenu.push(
        <DropdownMenu
            className="header__button header__settingsMenu settingsMenu"
            name="header__settingsMenu"
            align="left"
            closeOnOutsideClick={true}
            toggleLabel={translate('actions')}
            key="settingsMenu"
        >
            {session.features.includes(FeatureFlag.CRM) &&
                <MenuItem
                    onClickAction={() => (window.location.href = `${env.WEBAPP_HOST}accounts`)}
                    label={translate('launch_statflo_crm')}
                    target="_blank"
                    key="statfloCrm"
                />
            }
        </DropdownMenu>
    );

    const headerRightContent = /* onDesktop */ true ? null : mobileMenu;
    return Array.isArray(filteredConversations) ? (
        <>
            <div className="conversationsList__view border-right">
                <Header
                    session={session}
                    title={translate('conversations')}
                    rightContent="renderChildren"
                >
                    {headerRightContent}
                </Header>
                <Tabs translate={translate} onChange={handleSwitchTabs} unread={unreadConversations}>
                    <TabContent label={translate('inbox')} active enabled>
                        {/* {
                            session.role in ConversationFilterRoles && !session.features.includes(FeatureFlag.DISABLE_CONVERSATION_TYPE) && // role permissions check
                            <ConversationTypeFilter
                                handleChangeFilter={handleChangeFilter}
                                filterState={filterState}
                            />
                        } */}
                        <SearchInput
                            label="conversationsList"
                            setSearchValue={setSearchValue}
                            placeholder={translate('filter_by_name_number')}
                            searchValue={searchValue}
                        />
                        {/*PLACEHOLDER GOES HERE*/}
                        {(inboxPlaceholder.placeholderRoute && inboxPlaceholder.placeholderRoute.length !== 0) && <InboxPlaceholder translate={translate} />}
                        {/* <NextConversationItem /> */}
                        {
                            !loading ?
                                <ConversationScroll handleClick={handleClick} conversationList={filteredConversations} />
                                : <LoadingAnimation />
                        }
                    </TabContent>
                    <TabContent label={translate('smart_list')} enabled={hasSmartList}>
                        <SmartListComponent
                            translate={translate}
                            state={state}
                            session={session}
                            dispatchState={dispatchState}
                            dispatchFilters={dispatchFilters}
                            filters={filters}
                        />
                    </TabContent>
                </Tabs>
            </div>
            {
                // render a placeholder where the conversation will be
                !hasConversationId && onDesktop &&
                <div className="flexbox__column">
                    <div className="flexbox__row empty__state">
                        {selectedTab === 0 && <p>{translate('conversation_select_chat')}</p>}
                        {selectedTab === 1 && <p>{translate('conversation_set_filters')}</p>}
                    </div>
                </div>
            }
        </>
    ) : null;
};

const ConversationScroll: React.StatelessComponent<any> = ({ contentRect, conversationList, handleClick }) => (
    <div className="conversationsList__scroll">
        <ReactList
            itemRenderer={renderConversationListItem.bind(null, handleClick, conversationList)}
            length={conversationList.length}
            type="variable"
        />
    </div>
);

export default ConversationsList;



// WEBPACK FOOTER //
// ./src/sections/ConversationsList/ConversationsListComponent.tsx